import SEO, { type Crumb } from '@/components/SEO';
import PageHeader from '@/components/PageHeader';
import { staticPage } from '@/lib/content';
import { EMAIL } from '@/lib/site';

const Privacy = () => {
  const page = staticPage('/privacy');
  const crumbs: Crumb[] = [
    { name: 'Home', href: '/' },
    { name: 'Privacy', href: '/privacy' },
  ];
  return (
    <>
      <SEO title={page.title} description={page.description} path="/privacy" breadcrumbs={crumbs} />
      <PageHeader crumbs={crumbs} label="Privacy" title="Privacy" lead="How inquiries, browser tools and the services behind this site handle information." />
      <section className="container py-14 md:py-16">
        <div className="prose max-w-[46rem]">
          <h2>What we collect</h2>
          <p>
            <strong>Contact form.</strong> The form sends your name, email address, optional organization and phone
            number, selected topic and message to our inquiry service, hosted by Supabase. It also sends the contact
            page path and a recognized inquiry topic from the page link. We use those details to respond to your
            request. The service also records browser information and uses Google Workspace to send an internal notification and a confirmation email. Please leave passwords, customer documents and sensitive configuration out of the form.
          </p>
          <p>
            <strong>Hosting.</strong> Cloudflare hosts and delivers this site. Requests to the site include technical
            information such as your IP address, browser information and requested page, which the hosting service
            processes to deliver and protect the site.
          </p>
          <p>
            <strong>Analytics.</strong> The site uses a script supplied by Cloudflare Web Analytics for visit and
            page-performance statistics. Cloudflare describes this service as cookieless and says it does not track
            individual visitors across its customers’ websites. See{' '}
            <a href="https://developers.cloudflare.com/web-analytics/data-metrics/data-origin-and-collection/">
              Cloudflare’s description of its data collection
            </a>.
          </p>
          <p>
            <strong>Booking a call.</strong> If you book a call, the booking is handled by Google Calendar under
            Google's own <a href="https://policies.google.com/privacy">privacy policy</a> and terms.
          </p>
          <h2>Browser tools and storage</h2>
          <p>
            The tools calculate results in your browser. Their inputs are not sent to the inquiry service or included
            in analytics events by the site’s tool code. You choose what to include if you later contact us.
          </p>
          <p>
            This site does not set advertising cookies or load advertising trackers. Fonts and images are hosted
            with the site. Temporary browser-session values help recover from an outdated page after a site update;
            they do not contain form or tool inputs.
          </p>
          <h2>Service providers</h2>
          <p>
            Cloudflare, Supabase and Google process information when you use the services described above, including inquiry notification and confirmation emails. This
            service-provider processing is part of delivering the site, handling inquiries and arranging calls.
          </p>
          <h2>Questions about your information</h2>
          <p>
            To ask what we hold about an inquiry, how it is retained, or to request correction or deletion, email{' '}
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
          </p>
          <h2>Changes</h2>
          <p>Last reviewed September 16, 2026. This notice is reviewed when the site’s services or data handling change.</p>
        </div>
      </section>
    </>
  );
};

export default Privacy;
